<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="form-panel h-100 px-10 mb-16">
    <section
      v-if="showLttCountryWarning"
      class="d-flex flex-column justify-center align-center h-100"
    >
      <p class="text-h5">
        {{ $t('action.panels.INITIAL.countriesRestricted.title', locale, { countryNames }) }}
      </p>
      <p class="">
        {{
          $tc(
            'action.panels.INITIAL.countriesRestricted.descriptionPlural',
            formConfig.countries_restricted.length,
            locale,
            { countryNames }
          )
        }}
      </p>
      <p class="text-h5">
        <a @click="$store.commit('actionForm/SET_COUNTRY_WARNING_ENABLED', false)">
          {{ $t('action.panels.INITIAL.countriesRestricted.link', locale) }}
        </a>
      </p>
    </section>
    <section v-else-if="showOneClick">
      <p class="font-weight-bold">
        {{ $t('action.welcomeUser', locale, { name: akName }) }}
      </p>
      <p>{{ formConfig.auto_fill_form_copy || $t('action.signPetition', locale) }}</p>
      <p>
        {{ $t('action.userCheck', locale, { name: akName }) }}<br />
        <a :href="cleanFormUrl" @click.prevent="handleUserIncorrect">
          {{ $t('action.formLinkLabel', locale) }}
        </a>
      </p>
    </section>
    <template v-if="initialised">
      <template v-if="!showLttCountryWarning">
        <div v-if="isLTT" class="mb-2">
          <div class="text-h5 font-weight-bold">
            {{ $t('action.panels.INITIAL.sendYourEmailMessage', locale) }}
          </div>
          <div class="text-h6 font-weight-bold">{{ initialLttInstruction }}</div>
        </div>
        <div v-if="!showOneClick" class="w-100 mb-4">
          <section-dynamic-fields />
        </div>
      </template>
      <section class="form-actions">
        <section-data-consent v-if="showOptIn" />
        <section-sms-consent v-if="showSmsOptIn && !showOneClick" v-on="$listeners" />
        <section-3p-email-consent />
        <template v-if="!showLttCountryWarning">
          <v-btn
            name="sign-email"
            type="submit"
            color="primary"
            class="text-uppercase font-weight-bold"
            large
            :disabled="buttonDisabled"
          >
            <template v-if="isLTT">
              <v-icon v-if="!isSingleRepLTT" large>
                {{ icons.mdiMagnify }}
              </v-icon>
              &nbsp;
            </template>
            {{ signButtonLabel }}
          </v-btn>
          <section-disclaimer />
        </template>
      </section>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { mdiMagnify } from '@mdi/js'
import SectionDynamicFields from './sections/SectionDynamicFields'
import SectionDataConsent from './sections/SectionDataConsent'
import Section3pEmailConsent from './sections/Section3pEmailConsent'
import SectionDisclaimer from './sections/SectionDisclaimer'

export default {
  name: 'PanelInitial',
  components: {
    SectionDynamicFields,
    SectionDataConsent,
    Section3pEmailConsent,
    SectionDisclaimer
  },
  props: {
    onUserIncorrectClick: {
      type: Function,
      required: true
    },
    formValid: {
      type: Boolean,
      default: false
    }
  },
  data: vm => ({
    icons: {
      mdiMagnify
    }
  }),
  computed: {
    ...mapState('actionForm', ['formConfig', 'locale', 'showOneClick', 'initialised']),
    ...mapGetters('actionForm', [
      'isLTT',
      'isSingleRepLTT',
      'isInteractive',
      'phoneFieldPermitted',
      'hasPhoneField',
      'showOptIn',
      'showSmsOptIn',
      'akName',
      'showLttCountryWarning'
    ]),

    buttonDisabled() {
      return !(this.isInteractive && this.formValid)
    },
    countryNames() {
      return this.formConfig.countries_restricted.map(([code, name]) => name).join(', ')
    },
    initialLttInstruction() {
      return this.isSingleRepLTT
        ? this.$t('action.panels.INITIAL.lttInstructionSingleRep', this.locale)
        : this.$t('action.panels.INITIAL.lttInstruction', this.locale)
    },
    signButtonLabel() {
      if (this.formConfig.sign_button_label) {
        return this.formConfig.sign_button_label
      } else if (this.isSingleRepLTT) {
        return this.$t('action.ltt.buttons.action.singleRepLabel', this.locale)
      } else if (this.isLTT) {
        return this.$t('action.ltt.buttons.action.label', this.locale)
      } else {
        return this.$t('action.signWithEmail', this.locale)
      }
    },
    cleanFormUrl() {
      const url = new URL(window.location.href)
      url.searchParams.delete('akid')
      return url.pathname + url.search + '#form-section'
    }
  },

  methods: {
    handleUserIncorrect() {
      this.onUserIncorrectClick()
      window.location.href = this.cleanFormUrl
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_panels-common.scss';

.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
